import React, { Component } from 'react';
import axios from 'axios';
import './help-chat.css';

export default class HelpChat extends Component {
  constructor(props) {
    super(props);

    this.messageRef = React.createRef();

    this.state = {
      "loading": false,
      "messages": [],
      "render_video": null
    }
  }

  componentDidMount() {
    var _this = this;
    this.messageRef.current.addEventListener("keyup", function(e) {
      var key = e.which || e.keyCode;
      if (key === 13) {
        _this.onSendMessage();
      };
    });
  }

  async onSubmitIaText(message) {
    this.setState({"loading": true})
    const responseAi = await axios.post(`http://localhost:3000/api/openai/help`, {
      "text": message
    });

    var response = JSON.parse(responseAi.data.result.replaceAll(":\n", "").replaceAll("\n", ""))
    var messages = this.state.messages;
    if (response.video_url === null) {
      messages.push({
        "type": "text",
        "owner": "ai",
        "text": "Desculpe, não identificamos a sua dúvida, entre em contato com suporte@digitalpages.com.br."
      });
    } else {
      messages.push({
        "type": "video",
        "owner": "ai",
        "text": "Legal! Esse vídeo abaixo com o passo a passo pode te ajudar:",
        "video": response.video_url
      });
    }

    this.setState({
      "loading": false,
      "messages": messages
    });
  }

  onSendMessage() {
    var value = this.messageRef.current.value;
    this.onSubmitIaText(this.messageRef.current.value);
    var messages = this.state.messages;
    if (value !== "") {
      messages.push({
        "type": "text",
        "owner": "me",
        "text": value
      });
      this.setState({
        "messages": messages
      });
    };
    this.messageRef.current.value = "";
  }

  onOpenVideo(video) {
    this.setState({
      "render_video": video
    })
  }

  render() {
    var _this = this;
    const {
      messages,
      loading,
      render_video
    } = this.state;
    return (
      <div className="rdp-component-help-chat">
        <div className="rdp-component-help-chat-header">
          Assistente Virtual
        </div>
        <div className="rdp-component-help-chat-messages">
          {messages.map(function (message, index) {
            return <div key={index} className={`rdp-component-help-chat-message ${message.owner}`}>
              {message.type === "text" &&
                <span className="rdp-component-help-chat-message-text">{message.text}</span>
              }
              {message.type === "video" &&
                <>
                  <span className="rdp-component-help-chat-message-text">{message.text}</span>
                  <div className="rdp-component-help-chat-message-video" onClick={() => _this.onOpenVideo(message.video)}>
                    <video src={message.video}></video>
                    <span className="rdp-component-help-chat-message-video-icon"></span>
                  </div>
                </>
              }
            </div>
          })}
          {loading && <span className="rdp-composer-help-chat-preloader"></span>}
        </div>
        <div className="rdp-component-help-chat-actions">
          <input ref={this.messageRef} className="rdp-component-help-chat-actions-input" type="text"/>
          <button className="rdp-component-help-chat-actions-button" onClick={() => this.onSendMessage()}></button>
          
        </div>

        {render_video &&
          <div className="rdp-component-help-chat-video-modal">
            <div className="rdp-component-help-chat-video-modal-overlay" onClick={() => this.setState({"render_video": null})}></div>
            <div className="rdp-component-help-chat-video-modal-video">
              <video controls src={render_video}/>
            </div>
          </div>
        }
      </div>
    );
  }
}
